




import {Component, Prop, Vue} from 'vue-property-decorator';

let glyphs: { [key: string]: string };

/**
 * @status stable
 * @published 4.0.0
 * @changelog 4.0.0 Published.
 */
@Component
export default class JdsGlyph extends Vue {

    @Prop({default: ''}) for!: string;

    get glyph() {
        if (!glyphs) {
            this.preload();
        }

        if (Object.keys(glyphs).includes(this.for)) {
            return glyphs[this.for];
        }
        return '';
    }

    protected preload() {
        glyphs = {};
        // in non-webpack environments, such as Jest, require.context will fail. We can ignore this.
        try {
            const context = require.context('!raw-loader!./glyphs', true, /.html$/);
            glyphs = context.keys().reduce((iconMapping: { [key: string]: string }, key) => {
                const filename = key.substring(key.lastIndexOf("/") + 1);
                iconMapping[filename.substring(0, filename.length - 5)] = context(key).default;
                return iconMapping;
            }, {});
        } catch(e) {}
    }

}
